// Validate if a value is within a given array of values
export const valueIsWithin = (array, value) => array.some((element) => element == value);
// Validdate if a string is empty
export const isEmpty = (value) => value === undefined || value === null || !value.trim().length > 0;
// Validdate if a string is not empty
export const isNotEmpty = (value) => !isEmpty(value);
// Validdate if cuil is valid
export const isCuitValid = (cuit) => {
  try {
    if (cuit.startsWith("99-99999999-")) return true;
    if (cuit.startsWith("9999999999")) return true;
    if (![11, 13].includes(cuit.length)) return false;
    if (cuit.includes("-")) {
      if (cuit.split("-").filter(isNotEmpty).length != 3) return false;
      if (cuit.split("-").every(Number.isInteger)) return false;
    }

    let rv = false;
    let resultado = 0;
    let cuitnro = cuit.replace("-", "");
    let codes = "6789456789";
    let verificador = parseInt(cuitnro[cuitnro.length - 1]);
    let x = 0;

    while (x < 10) {
      let digitoValidador = parseInt(codes.substring(x, x + 1));
      if (isNaN(digitoValidador)) digitoValidador = 0;
      let digito = parseInt(cuitnro.substring(x, x + 1));
      if (isNaN(digito)) digito = 0;
      let digitoValidacion = digitoValidador * digito;
      resultado += digitoValidacion;
      x++;
    }
    resultado = resultado % 11;
    rv = resultado == verificador;
    return rv;
  } catch (error) {
    console.log(error);
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/helpers/validators.js